import { File } from './../../models/files/files.model';

export class PageTile {
    id?: string;
    title?: any;
    link?: any;
    custom_link?: any;
    icon?: string;
    page_id?: string;
    file?: File;
    joinData?: any;

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.link = options.link;
        this.custom_link = options.custom_link;
        this.icon = options.icon;
        this.page_id = options.page_id;
        this.file = options.file;
        this.joinData = options.joinData;
    }
}
